// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".social-step-editor-sidebar-media-file[data-v-6d16755c]{margin:16px;display:-ms-grid;display:grid;gap:16px;padding-bottom:20px}", ""]);
// Exports
module.exports = exports;
